import PropTypes from 'prop-types';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { getSubscriptionStatusAvatar } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormattedSubscriptionStatus = ({
  property,
  value,
  objectTypeId
}) => {
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx("span", {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [getSubscriptionStatusAvatar(value), getDisplayedValue(property, value, undefined, undefined, objectTypeId)]
  });
};
FormattedSubscriptionStatus.propTypes = {
  property: PropertyPropType.isRequired,
  value: PropTypes.string
};
export default FormattedSubscriptionStatus;